import { Marker, Popup } from 'react-leaflet';
import { generatePath } from 'react-router-dom';
import { Button } from '@accure/ui';
import { Icon } from 'leaflet';
import markerIconPng from 'leaflet/dist/images/marker-icon.png';

import type { SitePreviewExtended } from '@/api/fe-api/domain/entities/site';
import { GetOneSite } from '@/api/fe-api/view/queries/get-one-site';
import { OperationalPhase } from '@/components/sites/operational-phase';
import { PowerEnergy } from '@/components/sites/power-energy';
import { Link } from '@/components/ui/link';
import { siteLabel } from '@/utils/format/customer';

export type MapSiteProps = {
  sitePreview: SitePreviewExtended;
};

export function MapSite({ sitePreview }: MapSiteProps) {
  const site = GetOneSite.useQuery(sitePreview);
  const overviewUrl = generatePath('/asset/:siteId/overview', {
    siteId: sitePreview.id,
  });

  return (
    <Marker
      position={[sitePreview.lat, sitePreview.lng]}
      icon={
        new Icon({
          iconUrl: markerIconPng,
          iconSize: [25, 41],
          iconAnchor: [12, 41],
        })
      }
    >
      <Popup>
        <div className="-mr-4">
          <div className="mb-4 w-52 text-base">
            <h1 className="mb-1 font-bold">
              {siteLabel(sitePreview.fullFrontendId)}
            </h1>
            <div>
              {site.data?.isOk() && (
                <div className="text-sm text-zinc-500">
                  {site.data.value.address}
                </div>
              )}
              <div className="mt-2 space-y-2">
                <PowerEnergy site={sitePreview} />
                {site.data?.isOk() && (
                  <OperationalPhase
                    site={site.data.value}
                    className="inline text-sm"
                    variant="text"
                  />
                )}
              </div>
            </div>
          </div>
          <div className="flex justify-end">
            <Link to={overviewUrl}>
              <Button
                variant="ghost"
                className="text-primary-500 hover:bg-transparent hover:text-primary-600"
              >
                Go to Overview
              </Button>
            </Link>
          </div>
        </div>
      </Popup>
    </Marker>
  );
}
